import { MEDIA } from "./constants";
const helpers = {}, getTheme = (key, fallback) => {
  if (typeof window > "u")
    return;
  let theme;
  try {
    theme = localStorage.getItem(key) || void 0;
  } catch {
  }
  return theme || fallback;
}, getSystemTheme = (e) => (e || (e = window.matchMedia(MEDIA)), e.matches ? "dark" : "light");
export {
  getSystemTheme,
  getTheme,
  helpers
};
//# sourceMappingURL=helpers.js.map
